import handleQueryResult from "./util/handleQueryResult"
import type { AxiosInstance } from "axios"
import type { SearchFiltersData, SearchRequest } from "../SearchFilters"
import PatientConditionClient from "./PatientCondition.Client"
import PatientFakeClient from "./Patient.Fake.Client"

export type PatientSearchEntry = {
	patient: {
		patientId: number
		patientUuid: string
		userId: string
		firstName: string
		lastName: string
		email: string
		dateOfBirth: string
		isLockedOut?: boolean
		nhsNumber?: string
		chiNumber?: string
		genericIrelandPatientIdentifier?: string
		state: string
		deleteDate?: string
	}
	patientCondition: {
		patientConditionId: number
		patientConditionUuid: string
		problemAreaName: string
		treatmentCenterUuid: string
		spellNumber?: string
		consentToShare: boolean
		patientConditionCreatedDate: string
	}
}

type PatientSearchResult = {
	patients: PatientSearchEntry[]
	total: number
}

export class PatientClient {
	constructor(private axiosClient: AxiosInstance) {
		this.condition = new PatientConditionClient(this.axiosClient)
		this.fake = new PatientFakeClient(this.axiosClient)
	}

	private base = "/api/admin/patient"

	public condition: PatientConditionClient
	public fake: PatientFakeClient

	public getFilters = () =>
		handleQueryResult(
			this.axiosClient.get<SearchFiltersData>(`${this.base}/filters`)
		)

	public search = (request: SearchRequest) =>
		handleQueryResult(
			this.axiosClient.post<PatientSearchResult>(
				`${this.base}/list`,
				request
			)
		)
}
